import env from '../core/config/env'

class RequestCache {
  private ttl: number // Time To Live em ms
  private isDev: boolean

  constructor(ttlInSeconds: number) {
    this.ttl = ttlInSeconds * 1000
    this.isDev = env.ENVIRONMENT === 'dev'
  }

  private generateKey(key: string, params: any): string {
    return `${key}:${JSON.stringify(params)}`
  }

  public get<T>(key: string, params: any): T | null {
    const cacheKey = this.generateKey(key, params)
    const cachedItem = sessionStorage.getItem(cacheKey)

    if (!cachedItem) return null

    const { data, timestamp } = JSON.parse(cachedItem)
    const now = Date.now()

    if (now - timestamp > this.ttl) {
      sessionStorage.removeItem(cacheKey)
      return null
    }

    if (this.isDev) {
      console.log(`[CACHE HIT] Key: ${cacheKey}`)
    }

    return data as T
  }

  public set(key: string, params: any, data: any): void {
    const cacheKey = this.generateKey(key, params)
    const cacheEntry = {
      data,
      timestamp: Date.now(),
    }
    sessionStorage.setItem(cacheKey, JSON.stringify(cacheEntry))

    if (this.isDev) {
      console.log(`[CACHE SET] Key: ${cacheKey}`)
    }
  }

  public invalidate(key: string, params?: any): void {
    if (params) {
      const cacheKey = this.generateKey(key, params)
      sessionStorage.removeItem(cacheKey)
      if (this.isDev) {
        console.log(`[CACHE INVALIDATE] Key: ${cacheKey}`)
      }
    } else {
      // Invalida todas as chaves que começam com o prefixo
      Object.keys(sessionStorage).forEach((storageKey) => {
        if (storageKey.startsWith(`${key}:`)) {
          sessionStorage.removeItem(storageKey)
          if (this.isDev) {
            console.log(`[CACHE INVALIDATE] Key: ${storageKey}`)
          }
        }
      })
    }
  }
}

export default RequestCache
